<template aria-hidden="true">
  <svg
    aria-hidden="true"
    width="280"
    height="180"
    viewBox="0 0 280 180"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M217.17 46.4297H103.9C103.26 46.4297 102.63 46.4997 102.03 46.6297C101.43 46.4997 100.8 46.4297 100.16 46.4297H35.4403C30.6303 46.4297 26.7303 50.3297 26.7303 55.1397C26.7303 59.9497 30.6303 63.8497 35.4403 63.8497H42.9103C47.7203 63.8497 51.6203 67.7497 51.6203 72.5597C51.6203 77.3697 47.7203 81.2697 42.9103 81.2697H19.2603C14.4503 81.2697 10.5503 85.1697 10.5503 89.9797C10.5503 94.7897 14.4503 98.6897 19.2603 98.6897H46.6403C41.8303 98.6897 37.9303 102.59 37.9303 107.4C37.9303 112.21 41.8303 116.11 46.6403 116.11H126.3C121.49 116.11 117.59 120.01 117.59 124.82C117.59 129.63 121.49 133.53 126.3 133.53H197.25C202.06 133.53 205.96 129.63 205.96 124.82C205.96 120.01 202.06 116.11 197.25 116.11H247.04C251.85 116.11 255.75 112.21 255.75 107.4C255.75 102.59 251.85 98.6897 247.04 98.6897H215.92C211.11 98.6897 207.21 94.7897 207.21 89.9797C207.21 85.1697 211.11 81.2697 215.92 81.2697H265.71C270.52 81.2697 274.42 77.3697 274.42 72.5597C274.42 67.7497 270.52 63.8497 265.71 63.8497H217.16C221.97 63.8497 225.87 59.9497 225.87 55.1397C225.87 50.3297 221.97 46.4297 217.16 46.4297H217.17ZM14.2803 46.4297C9.47031 46.4297 5.57031 50.3297 5.57031 55.1397C5.57031 59.9497 9.47031 63.8497 14.2803 63.8497C19.0903 63.8497 22.9903 59.9497 22.9903 55.1397C22.9903 50.3297 19.0903 46.4297 14.2803 46.4297Z"
      fill="#F9FAFB"
    />
    <path
      d="M93.0794 128.3H80.3194C79.6494 128.3 79.1094 127.76 79.1094 127.09V43.8604C79.1094 43.1904 79.6494 42.6504 80.3194 42.6504H198.169C198.839 42.6504 199.379 43.1904 199.379 43.8604V127.08C199.379 127.75 198.839 128.29 198.169 128.29H110.689"
      fill="white"
    />
    <path
      d="M93.0794 128.3H80.3194C79.6494 128.3 79.1094 127.76 79.1094 127.09V43.8604C79.1094 43.1904 79.6494 42.6504 80.3194 42.6504H198.169C198.839 42.6504 199.379 43.1904 199.379 43.8604V127.08C199.379 127.75 198.839 128.29 198.169 128.29H110.689"
      stroke="#5359EA"
      stroke-width="2.5"
    />
    <path
      d="M189.67 51.1504H90.0401C89.3718 51.1504 88.8301 51.6921 88.8301 52.3604V119.19C88.8301 119.859 89.3718 120.4 90.0401 120.4H189.67C190.338 120.4 190.88 119.859 190.88 119.19V52.3604C190.88 51.6921 190.338 51.1504 189.67 51.1504Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
    />
    <path
      d="M93.6895 57.2295C93.6895 56.5595 94.2295 56.0195 94.8995 56.0195H153.219L133.779 115.55H94.8995C94.2295 115.55 93.6895 115.01 93.6895 114.34V57.2395V57.2295Z"
      fill="#EFF2F8"
    />
    <path
      d="M152.461 86.5704L131.501 98.6704C130.891 99.0204 130.131 98.5804 130.131 97.8804V73.6804C130.131 72.9804 130.891 72.5404 131.501 72.8904L152.461 84.9904C153.071 85.3404 153.071 86.2204 152.461 86.5704Z"
      fill="white"
      stroke="#5359EA"
      stroke-width="2.5"
    />
    <path
      d="M98.5508 128.3H104.621"
      stroke="#5359EA"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M231.19 59.6602H210.32M239.7 59.6602H237M223.51 69.1102H213.58"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M70.4805 106.77H60.5505M64.8005 96.0996H43.9305M36.8605 96.0996H31.7305"
      stroke="#A8B4F2"
      stroke-width="2.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
